import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import getImageUrlWithoutQuery from 'commons/getImageUrlWithoutQuery';
import brokenImageUrlsAtom from './brokenImageUrlsAtom';
const useSetBrokenImageUrl = () => {
  const $ = _c(2);
  const setBrokenImageUrlAtom = useSetAtom(brokenImageUrlsAtom);
  let t0;
  if ($[0] !== setBrokenImageUrlAtom) {
    t0 = brokenImageUrl => {
      if (!brokenImageUrl) {
        return;
      }
      const cleanBrokenImageUrl = getImageUrlWithoutQuery(brokenImageUrl);
      setBrokenImageUrlAtom(prevBrokenImageUrls => prevBrokenImageUrls.includes(cleanBrokenImageUrl) ? prevBrokenImageUrls : [...prevBrokenImageUrls, cleanBrokenImageUrl]);
    };
    $[0] = setBrokenImageUrlAtom;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setBrokenImageUrl = t0;
  return setBrokenImageUrl;
};
export default useSetBrokenImageUrl;